/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { theme, Loader } from "@nordcloud/gnui";

type Props = {
  loading: boolean;
};

export function GlobalSpinner({ loading }: Props) {
  if (loading) {
    return (
      <>
        {/* Make sure loader is above every other element in a stacking context */}
        <span
          css={{ zIndex: theme.zindex.topoftheworld + 1, position: "relative" }}
        >
          <Loader isBackground />
        </span>
      </>
    );
  }

  return null;
}
